export default {
  meta: {
    title: '任务码'
  }
};
